"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const debug = require("debug");
/**
 * Class to help with the logging to debug and optionally other streams
 */
class Logger {
    constructor(namespace) {
        this.namespace = namespace;
        this._logger = {
            debug: debug(`${Logger.prefix}${namespace}:debug`),
            error: debug(`${Logger.prefix}${namespace}:error`),
            info: debug(`${Logger.prefix}${namespace}:info`),
            log: debug(`${Logger.prefix}${namespace}:log`),
            warn: debug(`${Logger.prefix}${namespace}:warn`)
        };
    }
    /** Add a write stream that logs should be written to */
    static addStream(stream, filter) {
        this._writeStreams.push({ stream, filter });
    }
    /** Set prexfix
     *
     * @param value The prefix string
     */
    static setNamespacePrefix(value) {
        Logger.prefix = value;
    }
    /** Log debugging information
     *
     * @param message The message to log
     * @param ...rest The arguments to append
     */
    debug(message, ...rest) {
        this._log("debug", message, ...rest);
    }
    /** Log an error message
     *
     * @param message The message to log
     * @param ...rest The arguments to append
     */
    error(message, ...rest) {
        this._log("error", message, ...rest);
    }
    /** Log a verbose message
     *
     * @param message The message to log
     * @param ...rest The arguments to append
     */
    info(message, ...rest) {
        this._log("info", message, ...rest);
    }
    /** Log a message with the default log type
     *
     * @param message The message to log
     * @param ...rest The arguments to append
     */
    log(message, ...rest) {
        this._log("log", message, ...rest);
    }
    /** Log a warning message
     *
     * @param message The message to log
     * @param ...rest The arguments to append
     */
    warn(message, ...rest) {
        this._log("warn", message, ...rest);
    }
    /** Actually log the message
     *
     * @param message The message to log
     * @param ...rest The arguments to append
     */
    _log(logType, message, ...rest) {
        const logger = this._logger[logType];
        logger(message, ...rest);
        logger.enabled = true;
        if (logger.enabled && message instanceof Object) {
            for (const stream of Logger._writeStreams) {
                if (stream.filter[logType])
                    stream.stream.write(message);
            }
        }
    }
}
exports.Logger = Logger;
Logger.prefix = "";
/** The streams that loggers ALSO append to */
Logger._writeStreams = [];



//////////////////
// WEBPACK FOOTER
// ./src/shared/logger.ts
// module id = 189
// module chunks = 0 1 2